// Accounts & Ledger — the reporting figures an account code can count towards.
//
// A "reporting figure" is a numeric field on an Environmental topic form
// ("<topic>.<group>.<field>", e.g. transport.own_fleet.diesel_litres). Its value
// for a period is either automated (sum of the mapped codes' ledger lines,
// quantity or spend × factor) or typed in by hand — LEDGER.usp_Figure_List.

import { REPORTING_TEMPLATES } from "../../site-admin/report_management/blueprint/blueprintReportingTemplates";

/** Accounting packages — informational logo strip. */
export const ACCOUNTING_TOOLS = [
  { code: "xero", name: "Xero", logo: "/logos/accounting/xero.svg" },
  { code: "qbo", name: "QuickBooks", logo: "/logos/accounting/quickbooks.svg" },
  { code: "sage", name: "Sage", logo: "/logos/accounting/sage.svg" },
  { code: "bexio", name: "bexio" },
  { code: "abacus", name: "Abacus" },
  { code: "datev", name: "DATEV", logo: "/logos/accounting/datev.svg" },
  { code: "pennylane", name: "Pennylane" },
  { code: "sap", name: "SAP", logo: "/logos/accounting/sap.svg" },
  { code: "odoo", name: "Odoo", logo: "/logos/accounting/odoo.svg" },
  { code: "zoho", name: "Zoho Books", logo: "/logos/accounting/zoho.svg" },
];

/** Every numeric field on the Environmental topics, grouped by topic. */
export const LEDGER_FIGURE_TOPICS = REPORTING_TEMPLATES.filter((t) => t.pillar === "E").map((t) => ({
  key: t.key,
  name: t.name,
  figures: t.groups
    .filter((g) => g.key !== "evidence")
    .flatMap((g) =>
      g.fields
        .filter((f) => f.type === "number")
        .map((f) => ({ path: `${t.key}.${g.key}.${f.key}`, label: f.label, unit: f.unit || "", groupLabel: g.label, topicName: t.name })),
    ),
})).filter((t) => t.figures.length > 0);

export const LEDGER_FIGURES = LEDGER_FIGURE_TOPICS.flatMap((t) => t.figures);
export const figureByPath = (path) => LEDGER_FIGURES.find((f) => f.path === path) || null;

/** The value a topic form should use: hand-entered wins, else automated. */
export const effectiveValue = (row) => {
  if (!row) return null;
  if (row.manualValue !== null && row.manualValue !== undefined) return Number(row.manualValue);
  if (row.autoValue !== null && row.autoValue !== undefined) return Number(row.autoValue);
  return null;
};

/** Figures → { "<group>.<field>": value } for one topic form. */
export const figuresToTopicValues = (rows, topicKey) => {
  const out = {};
  (rows || []).forEach((r) => {
    if (!r.fieldPath || !r.fieldPath.startsWith(`${topicKey}.`)) return;
    const v = effectiveValue(r);
    if (v !== null && !Number.isNaN(v)) out[r.fieldPath.slice(topicKey.length + 1)] = v;
  });
  return out;
};
